import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ALTERNATIVE_MODAL_MAX_QUANTITY } from './constant';
import { formatPartNumber } from '@app/store/checkout/utils';

const useValidateQuantity = () => {
  const orderId = useSelector(s => s.orders.current);
  const orderItemSelector = useSelector(
    s => s.orders.byId?.[orderId]?.ascendingOrderItems || []
  );

  const itemsFromCart = useMemo(
    () =>
      orderItemSelector?.reduce((acc, item) => {
        const formattedPartNumber = formatPartNumber(item.partNumber);
        if (!acc[formattedPartNumber]) {
          acc[formattedPartNumber] = 0;
        }

        acc[formattedPartNumber] += parseInt(item.quantity);
        return acc;
      }, {}),
    [orderItemSelector]
  );

  const validateItemQuantity = useCallback(
    (item, itemQuantity) => {
      const currentQuantity = Object.keys(itemsFromCart ?? {}).length
        ? itemsFromCart[formatPartNumber(item.partNumber) || item.partName]
        : 0;
      return (
        currentQuantity + parseInt(itemQuantity) >
        ALTERNATIVE_MODAL_MAX_QUANTITY
      );
    },
    [itemsFromCart]
  );

  const validateAllItemQuantities = items => {
    const objKeys = Object.keys(items);

    return objKeys.some(key =>
      validateItemQuantity(items[key], items[key].requestedQuantity)
    );
  };

  return { validateAllItemQuantities, validateItemQuantity };
};

export default useValidateQuantity;
